import styled from 'styled-components';

const Container = styled.div`
  text-align: center;
`;

export const Styled = {
  Container,
};
